<template>
  <div id="wrapper">
    <cookie-disclaimer></cookie-disclaimer>
    <header id="TheHeader" class="sticky-top"><the-header></the-header></header>
    <router-view id="content"></router-view>
    <the-scroll-button></the-scroll-button>
    <footer id="TheFooter"><the-footer></the-footer></footer>
  </div>
</template>

<script>
import CookieDisclaimer from "@/UI/CookieDisclaimer.vue";
import TheHeader from "./UI/TheHeader.vue";
import TheFooter from "./UI/TheFooter.vue";
import TheScrollButton from "@/components/TheScrollButton.vue";

export default {
  components: { TheHeader, TheFooter, TheScrollButton, CookieDisclaimer },
}
</script>


<style>
body {
  margin: 0px;
  font-family: "Roboto", sans-serif;
  width: 100%;
}

.container{
  padding: 0;
}
.gap-sm {
  height: 20px;
}

.gap-md {
  height: 60px;
}

.gap-lg {
  height: 140px;
}

/* classes */
.secondary-grey {
  color: #6c757d;
}

.secondary-blue {
  color: #0062ff;
}

.primary-dark {
  color: #212331;
}

.primary-light {
  color: #f8f9fa;
}

.row {
  --bs-gutter-x: 0;
}

.lumabit-purple {
  color: #6f42c1;
}

.lumabit-pink {
  color: #e83e8c;
}

.baseLink {
  display: flex;
  justify-content: center;
  text-decoration: none;
}

.heading {
  background-image: linear-gradient(to right, #6f42c1, #e83e8c);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.baseButton {
  width: 160px;
  height: 42px;
  font-weight: 700;
  color: #f8f9fa;
  border: none;

  background: linear-gradient(to right,
      #6f42c1 0%,
      #e83e8c 30%,
      #00bcd4 51%,
      #6f42c1 100%);
  background-size: 400% auto;
  border-radius: 50px;
  transition: all 0.4s ease-in-out;
}

.baseButton:hover {
  background-position: 100% 0;
}

.baseButton:focus {
  outline: none;
  transform: scale(1.1);
}

/* HTML tag changes */
main {
  background-color: #f8f9fa;
}

h1 {
  font-family: "Roboto", sans-serif;
  font-size: 5rem;
  font-weight: 900;
}

h2 {
  font-family: "Roboto", sans-serif;
  font-size: 3.2rem;
  font-weight: 700;
}

h3 {
  font-family: "Roboto", sans-serif;
  font-size: 2.9rem;
  font-weight: 700;
}

h4 {
  font-family: "Roboto", sans-serif;
  font-size: 2rem;
  font-weight: 500;
}

p {
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-size: 1.2rem;
}

span {
  font-weight: 100;
}

.apearAnimation {
  opacity: 0;
  animation: opac 0.5s forwards;
}

@keyframes opac {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.jobCard {
  display: flex;
  text-align: center;
  width: 352px;
  height: 420px;
  background: #fdfdff;
  border-radius: 20px;
  border: 1px solid #e83e8d41;
  transition: all .2s ease-in;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.jobCard:hover {
  transform: scale(1.05);
}
a,
a:hover {
  color: #fdfdff;
  text-decoration: none;
}

/* Pick Roboto font weight: 100, 300, 400, 500, 700, 900 */
/* 22.05.2023: Currently only using 300, 500 and 700 thats why the rest is commented out, if needet remove comment */
/* @font-face {
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 100;
      src: url('~@/assets/Roboto/Roboto-Thin.ttf') format('truetype');
       font-display: swap;
    } */

@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 300;
  src: url('~@/assets/Roboto/Roboto-Light.ttf') format('truetype');
  font-display: swap;
}

/* @font-face {
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      src: url('~@/assets/Roboto/Roboto-Regular.ttf') format('truetype');
       font-display: swap;
    } */

@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  src: url('~@/assets/Roboto/Roboto-Medium.ttf') format('truetype');
  font-display: swap;
}


@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  src: url('~@/assets/Roboto/Roboto-Bold.ttf') format('truetype');
  font-display: swap;
}

@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 900;
  src: url('~@/assets/Roboto/Roboto-Black.ttf') format('truetype');
  font-display: swap;
}
</style>
